// Generated by CoffeeScript 2.7.0
var Flow, VERTEX_CONFIGS, config_comp;

import FinalVertexConfig from 'trunks/vue/admin/components/yet_another_workflow/vertex_config/final.js';

import InitialVertexConfig from 'trunks/vue/admin/components/yet_another_workflow/vertex_config/initial.js';

import NormalVertexConfig from 'trunks/vue/admin/components/yet_another_workflow/vertex_config/normal.js';

import AutomationVertexConfig from 'trunks/vue/admin/components/yet_another_workflow/vertex_config/automation.js';

import EdgeConfig from 'trunks/vue/admin/components/yet_another_workflow/edge_config.js';

import GraphConfig from 'trunks/vue/admin/components/yet_another_workflow/graph_config.js';

import GraphEditor from 'trunks/vue/admin/components/yet_another_workflow/graph_editor.js';

VERTEX_CONFIGS = {FinalVertexConfig, InitialVertexConfig, NormalVertexConfig, AutomationVertexConfig};

config_comp = {
  props: {
    element: {
      type: [Skylark.App.Model.YetAnotherWorkflow.Vertex, Skylark.App.Model.YetAnotherWorkflow.Edge, Skylark.App.Model.YetAnotherWorkflow.Graph],
      required: true
    }
  },
  render: function(h) {
    return h('div', {
      class: 'workflow-config'
    }, [
      h(this._getComponent(),
      {
        props: {
          element: this.element
        }
      })
    ]);
  },
  methods: {
    _getComponent: function() {
      if (this.element == null) {
        return {
          render: function(h) {
            return h();
          }
        };
      }
      if (this.element instanceof Skylark.App.Model.YetAnotherWorkflow.Vertex) {
        if (this.element.isAutomation) {
          return AutomationVertexConfig;
        } else {
          return VERTEX_CONFIGS[this.element.type.demodulize() + 'VertexConfig'];
        }
      } else if (this.element instanceof Skylark.App.Model.YetAnotherWorkflow.Edge) {
        return EdgeConfig;
      } else {
        return GraphConfig;
      }
    }
  }
};

export default Flow = Vue.extend({
  components: {
    'config': config_comp,
    'graph-editor': GraphEditor
  },
  props: {
    graph: Skylark.App.Model.YetAnotherWorkflow.Graph
  },
  data: function() {
    return {
      select_item: this.graph
    };
  },
  template: `<div class="workflow-content">
  <graph-editor v-if='graph' :graph='graph' @selectedChanged='selectedChangedFunc' />
  <config v-if='select_item' :element='select_item' />
</div>`,
  methods: {
    selectedChangedFunc: function(target) {
      return this.select_item = target;
    }
  }
});
